import { ICommand } from 'core-ts-types';
import { IReminderData, ReminderQuery } from 'data-ng-personal-reminders';
import * as _4 from 'lodash4';
import { TypeUtility } from 'utility-ts-type';
import { PathTaskFormatter } from '../../data/functions/path_task_formatter_fn';
import { PathTitleColorService } from '../../data/services/path_color_service';

interface IReminderDetailsModel {
  class: string;
  showNotes: boolean;
  subTitle: string;
}

export class TodoReminderDetailsController {
  private model: IReminderDetailsModel;
  private reminderData: IReminderData;

  constructor(
    private $state: ng.ui.IStateService,
    private ngReminderQuery: ReminderQuery,
    private ngTypeUtility: typeof TypeUtility,
    private editReminderCommand: ICommand,
    private EventCategoryEnum: any,
    private log: any,
    private pathTitleColorService: PathTitleColorService,
    private ngPathTaskFormatter: PathTaskFormatter
  ) {
    this.reminderData = this.ngReminderQuery.result;
    this.model = {
      class: this.pathTitleColorService.getTextColorClass('PERSONAL TO-DO'),
      showNotes: !_4.isEmpty(this.reminderData.description),
      subTitle: this.ngPathTaskFormatter.getReminderText(this.reminderData)
    };
  }

  goToEditReminder = () => {
    this.$state.go('my.newreminder', {
      personalTodoID: this.reminderData.id
    });
  };

  isReminderCompleted(reminder: IReminderData): boolean {
    return _4.isEqual(reminder.status, 'COMPLETED');
  }

  updateReminderStatus(): void {
    const newStatus = _4.isEqual(this.reminderData.status, 'ACTIVE') ? 'COMPLETED' : 'ACTIVE';

    this.editReminderCommand(this.reminderData.id, { status: newStatus })
      .then((response: object) => {
        this.reminderData.status = newStatus;
      })
      .catch((error: object) => {
        this.log.user.error('Something went wrong. Please try again!');
      });
  }
}

export class TodoReminderDetailsComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-todos/src/components/todo_reminder_details/todo_reminder_details.html';
  public controller: any = TodoReminderDetailsController;
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/components/todo_reminder_details/todo_reminder_details_controller.ts